<style>

</style>

<Auth bind:this="{auth}"></Auth>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "./Auth.svelte";
let auth;

import StoreCrypto from "../helpers/StoreCrypto.js";
import ShareCrypto from "../helpers/ShareCrypto.js";

// to store on the local device and in s3 - syncs on to new devices
export let me = {
  uid: "",
  name: "",
  email: "",
  phone: "",
  username: "",
  distanceEvents: 0,
  distanceFriends: 0,
  birthday: "",
  gender: "",
  agePreference: [],
  lookingFor: [],
  photoIds: [],
  interests: [],
  questions: [],
  lat: 0,
  long: 0,
  bio: "",
  socialLinks: [],
}

// to share with others
let share = {
  uid: "",
  name: "",
  username: "",
  birthday: "", // store MSB style, "1976-02-29"
  gender: 0, // store using Gender.js "i"
  lookingFor: [], // store like [1,7,11] - based on Gender.js "i"
  agePreference: [], // [20,40]
  photoIds: [], // reference / pointer to pic ids
  interests: [], // store like [1, 13, ...]
  questions: [], // store like [1, 5, ...] each element pos indicates the question
  lat: 0,
  long: 0,
  bio: "",
  socialLinks: [],
}


// loadMe is called externally and should not be called internally
export const loadMe = async () => {
  
  // me = meTest;
  // return;
  
  let res = await auth.post("loadMe", {fullProfile: false});
  
  res = JSON.parse(res);
  // console.log("res:", res);
  
  // decrypt "me"
  let pkey = localStorage.getItem("pkey");
  let cert = localStorage.getItem("cert");
  me = StoreCrypto.decrypt(res.store, pkey, cert);
  
  // store me as a still stringified JSON object
  // localStorage.setItem("store", me);
  
  me = JSON.parse(me);
  
  me.myInterests = [];
  me.myquestions = [];
  
  // console.log("me:", me);
  
}


// don't update share on change of these fields: ["email", "phone", "distanceEvents", "distanceFriends", "lat,long"];

export const updateMe = async (pref) => {
  
  auth.message("Saving Profile");
  
  console.log("me:", me);
  
  let cert = localStorage.getItem("cert");
  // encrypt store - store in s3
  let store = StoreCrypto.encrypt(JSON.stringify(me), cert);
  console.log("store:", store);
  console.log("store.length:", store.length);
  
  let send = {
    store: store,
    share: "",
  }
  
  if (pref.updateShare == true) {
    // copy me to share
    for (let i in share) {
      share[i] = me[i];
    }
    
    console.log("share:", share);
    
    // encrypt share - store in s3
    send.share = ShareCrypto.encrypt(share);
  }
  
  console.log("send:", send);
  
  let res = await auth.post("saveMe", send);
  console.log("saveMe res:", res);
  
  localStorage.setItem("store", JSON.stringify(me));
}




</script>